import { createRecipe } from './runtime';

const mediaConfig = {"name":"media"}

export const media = /* @__PURE__ */ createRecipe(mediaConfig)